export default {"src":"/_next/static/media/spinach.b4b562f0.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};